<template>
  <div class="min-height-for-section w-100 pt-livetv">
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col-12 col-lg-9">
          <div class="w-100">
            <VideoPlayer :id="player_id" :type="'video'" />
          </div>
          <div
            class="w-100 d-flex flex-row mt-4 align-items-center justify-content-between"
          >
            <div class="d-flex flex-column">
              <!-- <div class="small-logo mr-2 ">
                <img :src="small_icon" class="w-100" />
              </div> -->
              <div>
                <p class="w-100 text-left mb-2 title">{{ title }}</p>
              </div>
              <div>
                <p class="w-100 text-left mb-0 slogan">{{ channel_title }}</p>
              </div>
            </div>

            <div class="px-2">
              <div
                class="sharebtndiv d-flex flex-row align-items-center"
                @click="openModal(channel_title)"
              >
                <span class="mr-2">Share</span>
                <img src="@/assets/icon/share.svg" />
              </div>
              <social ref="social"></social>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div
            class="w-100 list-div d-flex flex-row flex-wrap flex-lg-column align-items-center mt-4 mt-lg-0"
          >
            <a
              class="item-list mx-2 mt-3 mx-lg-0 mt-lg-0 mb-lg-4 cursor-pointer"
              v-bind:class="{ active: player_id === item.id }"
              v-for="item in live_tv"
              :key="item.id"
              :href="
                $router.resolve({ path: '/live/' + getSlug(item.id) }).href
              "
            >
              <div
                class="main-item-wrapper d-flex flex-column position-relative"
              >
                <div class="item_img">
                  <img
                    v-bind:src="item.img_link"
                    @error="imageLoadError($event)"
                    class="img-class"
                  />
                  <div class="live-tag" v-if="item.data.customStatus == 'live'">
                    <div class="mr-1">
                      <img src="@/assets/icon/live.png" class="live-tag-img" />
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="latest-text">LIVE</span>
                    </div>
                  </div>
                </div>
                <div class="now-playing-div" v-if="player_id === item.id">
                  <p class="mb-0 now-playing-title">Now Playing</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="row mt-2 mt-lg-4">
        <div class="col-12">
          <BillboardBannerTop v-if="desktop"></BillboardBannerTop>
          <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import VideoPlayer from "@/components/players/videoPlayer.vue";
import social from "../components/popup/sharepopup";
import BillboardBannerTop from "../components/ads/v2/live/billboardBannerTop.vue";
import MrecBannerBottom from "../components/ads/v2/live/mrecBannerTop.vue";
import DesktopInterstitial from "../components/ads/interstitial/interstitial/desktopInterstitial.vue";
import MobileInterstitial from "../components/ads/interstitial/interstitial/mobileInterstitial.vue";
import { bus } from "../main";
export default {
  data: function() {
    return {
      share: [],
      live_tv: [],
      player_id: "",
      initialization: false,
      active_obj: [],
      title: "",
      small_icon: "",
      channel_title: "",
      mobile: false,
      desktop: false,
      tablet: false,
      exclude_id: 3902,
      loading: true,
    };
  },
  components: {
    social,
    VideoPlayer,
    BreadCrumbsHeader,
    BillboardBannerTop,
    MrecBannerBottom,
    DesktopInterstitial,
    MobileInterstitial,
  },
  methods: {
    filterLiveTv() {
      var vm = this;

      var tv_order = [2, 3391, 1229];

      var data = vm.$store.state.live_tv.data;

      data.sort(function(a, b) {
        return tv_order.indexOf(a.id) - tv_order.indexOf(b.id);
      });

      vm.live_tv = data;
      // console.log(JSON.stringify(vm.live_tv, null, 2));

      var store = [];
      vm.live_tv.forEach((item) => {
        if (item.id != this.exclude_id) {
          item["img_link"] = vm.imgFiltering(item);
          store.push(item);
        }
      });

      vm.live_tv = store;

      vm.initialization = true;
    },
    initializeFirstId() {
      this.setCurrentId(this.live_tv[0]);
    },
    setCurrentId(item) {
      this.player_id = parseInt(item.id);
      this.title = item.title;
      this.small_icon = item.img_link;
      this.channel_title = item.data.slogan;

      this.initializecontentview();
      this.initializepageview();
    },
    getSlug(id) {
      var slug;
      if (id == 2) {
        slug = "SUKMAINDERA";
      } else if (id == 3391) {
        slug = "ANEKA";
      } else if (id == 1229) {
        slug = "GOLIVE";
      }

      return slug;
    },
    itemClick(item) {
      var slug;
      if (item.id == 2) {
        slug = "SUKMAINDERA";
      } else if (item.id == 3391) {
        slug = "ANEKA";
      } else if (item.id == 1229) {
        slug = "GOLIVE";
      }

      this.$router.resolve({ path: "/live/" + slug }).href;
    },
    getRelatedItems(current_id) {
      this.live_tv.forEach((item) => {
        if (parseInt(current_id) == parseInt(item.id)) {
          this.setCurrentId(item);
        }
      });
    },
    openModal(channel_title) {
      this.share = {
        url: window.location.origin + this.$route.fullPath,
        title: channel_title,
      };

      bus.$emit("shareVar", this.share);
      this.$refs.social.show();
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.player_id, // Content ID from content api response
          contentTitle: self.title,
          site: "RTBGo",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          //   console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: self.title,
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    checkFirstLoad() {
      var vm = this;

      Vue.nextTick(
        function() {
          setTimeout(
            function() {
              vm.loading = !vm.loading;
            }.bind(this),
            400
          );
        }.bind(vm)
      );
    },
  },
  created() {
    this.$store.dispatch("fetchLiveTV", { self: this });
  },
  mounted() {
    this.deviceCheck();
    this.checkFirstLoad();
    setTimeout(
      function() {
        if (!this.$route.params.id) {
          // get the first id
          this.initializeFirstId();
        } else {
          //directly set the active player object
          var params = this.$route.params.id;
          var id;

          if (
            params == "GoLIVE" ||
            params == "GOLIVE" ||
            params == "Golive" ||
            params == "golive"
          ) {
            id = 1229;
          } else if (
            params == "Aneka" ||
            params == "ANEKA" ||
            params == "aneka"
          ) {
            id = 3391;
          } else if (
            params == "Sukmaindera" ||
            params == "SUKMAINDERA" ||
            params == "sukmaindera"
          ) {
            id = 2;
          }

          this.getRelatedItems(id);
        }
      }.bind(this),
      800
    );
  },
  destroyed() {
    $("#vidBox").empty();
  },
};
</script>

<style scoped>
.min-height-for-section {
  /* min-height: 100vh; */
  padding-bottom: 80px;
}
.cursor-pointer {
  cursor: pointer;
}
.pt-livetv {
  padding-top: 20px;
}
.item_img {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  z-index: 20;
  background: #eae7e5;
}
.item_img .img-class {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.item-list {
  width: 100% !important;
}
.live-tag {
  position: absolute;
  top: 6px;
  left: 6px;
  padding: 2px 5px;
  background: #ff0000;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: row;
  align-items: center;
}
.live-tag .live-tag-img {
  width: 16px;
}
.latest-text {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.14;
  text-align: left;
  color: #ffffff;
}
.title {
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #fab92b;
  font-family: "Poppins", sans-serif !important;
}
.slogan {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #fff;
  font-family: "Poppins", sans-serif !important;
}
.small-logo {
  width: 82px;
  border-radius: 8px;
  overflow: hidden;
}
.active {
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: 100%;
  border: 3px solid #fab900;
}
.now-playing-div {
  padding: 4px 10px;
  background: #f9b91b;
  position: absolute;
  bottom: 0;
  right: 0;
  border-top-left-radius: 4px;
  display: flex;
  align-items: center;
}
.now-playing-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  color: #292929;
  padding-top: 2px;
}
.sharebtndiv {
  cursor: pointer;
}
.sharebtndiv span {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  color: #facb43;
  font-family: "Poppins", sans-serif !important;
}
.sharebtndiv img {
  width: 20px;
}

@media only screen and (max-width: 992px) {
  .item-list {
    width: 45% !important;
  }

  .min-height-for-section {
    padding-bottom: 40px;
  }
  .list-div {
    max-width: 100%;
    margin: 0 auto;
  }
  .active::before {
    content: "";
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .min-height-for-section {
    min-height: 70vh;
  }
  .pt-livetv {
    padding-top: 20px;
  }

  .live-tag {
    padding: 2px 4px;
    height: 16px;
  }
  .live-tag .live-tag-img {
    width: 12px;
  }
  .latest-text {
    font-size: 10px;
  }
  .title,
  .now-playing-title,
  .sharebtndiv span {
    font-size: 12px;
  }
  .small-logo {
    width: 42px;
  }
}
@media only screen and (max-width: 480px) {
  .active::before {
    display: none;
  }
  .sharebtndiv img {
    width: 16px;
  }
}
</style>

<style>
.bg-blur {
  background: url("../assets/bg-blur.png");
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size: contain;
  background-position: top left;
  background-repeat: no-repeat;
  height: 100%;
}
</style>
